/**
 * GuestGateModal — pairs with useGuestGate() hook.
 *
 * Single-line drop-in at the bottom of any page that uses the gate:
 *
 *   const { gate, sheetOpen, sheetTitle, setSheetOpen, returnUrl } = useGuestGate();
 *   ...
 *   {sheetOpen && <GuestGateModal title={sheetTitle} returnUrl={returnUrl} onClose={() => setSheetOpen(false)} />}
 *
 * Reuses the existing QuickOTPModal in guest mode — same login/signup
 * forms, same OTP flow, same agent/institution register links.
 *
 * Mar 1, 2026.
 */
import QuickOTPModal from '@/components/QuickOTPModal';

export default function GuestGateModal({ title, returnUrl, onClose }) {
  // On success: QuickOTPModal calls onSuccess(userData). The AuthPage
  // honours `?return=` query param but inside the in-page modal we just
  // close ourselves and let the page rerender with `user` populated —
  // the auth state is global so the parent component refreshes
  // automatically.
  const handleSuccess = () => {
    if (typeof onClose === 'function') onClose();
  };
  return (
    <QuickOTPModal
      onSuccess={handleSuccess}
      onClose={onClose}
      dismissable={true}
      guestMode={true}
      guestTitle={title}
      returnUrl={returnUrl}
    />
  );
}
